import { render, staticRenderFns } from "./cTemplateBuilderHierarchyCopy.vue?vue&type=template&id=45abc044&scoped=true"
import script from "./cTemplateBuilderHierarchyCopy.vue?vue&type=script&lang=js"
export * from "./cTemplateBuilderHierarchyCopy.vue?vue&type=script&lang=js"
import style0 from "./cTemplateBuilderHierarchyCopy.vue?vue&type=style&index=0&id=45abc044&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45abc044",
  null
  
)

export default component.exports